<template>
  <v-card class="pt-0" min-width="100px" min-height="300px">
    <v-col class="pt-0">
      <v-row>
        <v-card color="primaryDark" min-height="55px" width="100%" dark class="pa-2 subtitle-1">
          <v-row dense>
            <v-col align-self="center" class="pl-4 pa-0">
              Resources
            </v-col>
            <template v-for="(action, index) in actions">
              <v-col
                cols="auto"
                class="pl-4 pr-4"
                :key="index"
                v-if="
                  !action.editAssets ||
                    (CanUserEditAssets() && action.editAssets)
                "
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="icon-btn"
                      icon
                      v-on:click="HandleFunctionCall(action.onClick)"
                      :color="action.isToggled ? 'teal' : ''"
                    >
                      <v-icon size="24" light v-on="on">{{
                        action.icon
                      }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ action.description }}</span>
                </v-tooltip>
              </v-col>
            </template>
          </v-row>
        </v-card>
      </v-row>
    </v-col>
    <v-container ref="resourceCarousel" fluid class="pa-0" :style="carouselViewportStyle">
      <v-carousel
        :style="carouselViewportStyle"
        :show-arrows="showResourceArrows"
        show-arrows-on-hover
        v-model="carouselIndex"
        :height="carouselHeight"
        v-if="!hideResources"
        :hide-delimiters="!showResourceDetail"
      >
        <v-btn
          small
          style="position:absolute;z-index:1;right:0px;"
          height="50px"
          width="50px"
          @click="OnExpandResourceView"
          color="rgba(0,0,0,0.4)"
          class="pa-0"
        >
          <v-icon v-if="fullScreenResourceMode">
            mdi-fullscreen
          </v-icon>
          <v-icon v-else>
            mdi-fullscreen-exit
          </v-icon>
        </v-btn>

        <!--
                    Hiding old fullscreen button as some menus don't work with in full view, better maybe to do it as a state till vuetify upgrade
                <v-btn small style="position:absolute;z-index:1;right:0px;" height="50px" width="50px" v-on:click="ShowResourcesFullScreen" color="rgba(0,0,0,0.4)" class="pa-0">
                    <v-icon v-if="fullScreenResourceMode">
                        mdi-fullscreen
                    </v-icon>
                    <v-icon v-else>
                        mdi-fullscreen-exit
                    </v-icon>
                </v-btn>
                -->
        <v-carousel-item
          v-for="(item, i) in this.asset.resources"
          :key="item.id || i"
          class="resourceCarouselItem"
          :style="carouselViewportStyle"
        >
          <AssetResourceView
            :isFullScreen="fullScreenResourceMode"
            :isActive="carouselIndex == i"
            :viewHeight="carouselHeight"
            :resource="item"
            :showMetaDetails="showResourceDetail"
          ></AssetResourceView>
        </v-carousel-item>
      </v-carousel>
    </v-container>
    <v-container>
      <v-row justify="center">
        <v-dialog v-model="importDialog" width="700px">
          <v-card class="ma-0 pa-3" flat width="700px">
            <v-card-title class="mb-0 pb-0">
              <span class="headline">Asset Resources</span>
            </v-card-title>
            <v-container class="pt-0 mt-0">
              <v-col class="pt-0">
                <v-row no-gutters align="end">
                  <v-col cols="auto">
                    <v-switch
                      dense
                      label="Replace Resources"
                      v-model="replacementUpload"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="auto">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          color="primary"
                          class="ml-2"
                          light
                          size="24"
                          v-on="on"
                          >mdi-information</v-icon
                        >
                      </template>
                      <span
                        >If enabled, uploaded assets will ONLY replace assets
                        with the same name and file type.</span
                      >
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row no-gutters align="end">
                  <v-col cols="auto">
                    <v-switch
                      dense
                      label="Seperate underscores into tags"
                      v-model="seperateUnderscoresIntoTags"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="auto">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          color="primary"
                          class="ml-2"
                          light
                          size="24"
                          v-on="on"
                          >mdi-information</v-icon
                        >
                      </template>
                      <span
                        >If enabled, any underscore characters after the first
                        name will be used as tags (for example 'product_t' will
                        result in a new resource called product with the tag
                        't'.</span
                      >
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row no-gutters v-if="autoCropTokens != -1" align="end">
                  <v-col cols="auto">
                    <v-switch
                      dense
                      label="Auto Crop"
                      v-model="autoCropEnabled"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="auto">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          color="primary"
                          class="ml-2"
                          light
                          size="24"
                          v-on="on"
                          >mdi-information</v-icon
                        >
                      </template>
                      <span
                        >If enabled, uploaded assets that are JPG / PNG file
                        types will have their backgrounds removed and empty
                        space cropped. This will cost one token per image.</span
                      >
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" class="pt-2 pb-2">
                    <b>{{ autoCropTokens }} </b> Tokens left
                  </v-col>
                </v-row>
                <v-row v-if="claims.canUploadLargeFiles">
                  <v-card
                    flat=""
                    @click="showAdvancedOptions = !showAdvancedOptions"
                    class="mt-2"
                  >
                    Advanced Options
                    <v-icon v-if="!showAdvancedOptions">
                      mdi-chevron-down
                    </v-icon>
                    <v-icon v-else>
                      mdi-chevron-up
                    </v-icon>
                  </v-card>
                </v-row>
                <v-row v-if="showAdvancedOptions && claims.canUploadLargeFiles">
                  <v-switch
                    v-model="uploadAs360Asset"
                    label="Upload as 360 Image Sequence"
                  ></v-switch>
                </v-row>
                <v-row class="cardcontent">
                  <v-col cols="4" class="pa-1" justify="center" align="center">
                    <v-card height="190px" class="justify-center">
                      <v-img
                        max-height="190px"
                        contain
                        :src="this.files.length ? this.files[0].thumb : ''"
                      />
                    </v-card>
                  </v-col>
                  <v-col cols="8" class="pa-1">
                    <v-card
                      class="upload"
                      color="transparent"
                      min-height="200px"
                      flat
                    >
                      <v-simple-table v-if="this.files.length">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">File Name</th>
                              <th class="text-left"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(file, index) in files" :key="file.id">
                              <td>{{ file.name }}</td>
                              <td>
                                <v-btn
                                  class="icon-btn"
                                  color="red"
                                  icon
                                  @click="files.splice(index, 1)"
                                >
                                  <v-icon>mdi-file-remove</v-icon>
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>

                      <v-container class="fill-height pa-4" fluid>
                        <v-row justify="center" align="center">
                          <v-btn max-width="220px">
                            <label
                              for="file"
                              class="btn btn-lg btn-primary"
                              style=""
                            >
                              Drop or Select Files
                            </label>
                          </v-btn>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-container>
            <v-card-actions>
              <v-row justify="center" style="margin: 0px">
                <v-btn
                  color="blue-grey lighten-5"
                  @click="Cancel()"
                  :disabled="this.uploadingImages"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="primary"
                  class="mr-4"
                  :disabled="this.files.length == 0 || this.uploadingImages"
                  @click="updateAssetImages()"
                >
                  <v-icon
                    v-if="this.uploadingImages"
                    size="28"
                    color="white"
                    dark
                  >
                    mdi-loading mdi-spin
                  </v-icon>
                  <span v-else>Upload</span>
                </v-btn>
              </v-row>
            </v-card-actions>
            <file-upload
              :multiple="true"
              :drop="true"
              :drop-directory="true"
              :maximum="5000"
              accept="image/*"
              @input-filter="inputFilter"
              v-model="files"
              ref="upload"
              :headers="GetAuthHeaderObj()"
            ></file-upload>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
    <div v-if="this.downloadingResources" class="text-center">
      <v-overlay>
        <Loading :value="'Downloading...'"></Loading>
      </v-overlay>
    </div>
    <v-dialog v-model="confirmDeleteDialog" max-width="400px">
      <v-card>
        <v-card color="primaryDark" dark flat class="pa-3 subtitle-1">
          Delete Resource
        </v-card>
        <v-card-text class="pt-4">
          Are you sure you want to delete this resource?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="confirmDeleteDialog = false">
            Cancel
          </v-btn>
          <v-btn color="red" dark @click="ConfirmDeleteResource()">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import CONFIG from "../../../appconfig.json";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";

import AssetResourceView from "../../views/assetDetail/AssetResourceView.vue";
import FileUpload from "vue-upload-component";
import Loading from "../../shared/Loading";
import Vue from "vue";
import axios from "axios";

import { GetAuthorisationHeaderGroup } from "@/vuex/assetxphelpers";

export default {
  name: "AssetResources",
  components: {
    AssetResourceView,
    FileUpload,
    Loading,
  },
  props: {},
  computed: {
    ...mapState("assetxpstate", ["asset", "downloadingResources"]),
    ...mapState("authentication", ["claims"]),
    ...mapState("sessionState", ["showResourceArrows", "resourceViewExpanded"]),
    carouselViewportStyle() {
      return {
        height: this.carouselHeight,
        maxHeight: this.carouselHeight,
        overflow: "hidden",
      };
    },
  },
  data() {
    return {
      seperateUnderscoresIntoTags: true,
      autoCropEnabled: false,
      autoCropTokens: -1,
      replacementUpload: false,
      showAdvancedOptions: false,
      uploadAs360Asset: false,
      fullScreenMode: false,
      hideResources: false,
      fullScreenResourceMode: false,
      carouselHeight: "400px",
      showResourceDetail: false,
      importDialog: false,
      confirmDeleteDialog: false,
      carouselIndex: 0,
      files: [],
      file: {},
      uploadingImages: false,
      importJobId: null,
      actions: [
        {
          description: "Show Details",
          icon: "mdi-details",
          onClick: "OnShowDetails",
          isToggled: false,
          editAssets: true,
        },
        {
          description: "Set as Asset thumbnail",
          icon: "mdi-flag",
          onClick: "SetDefaultImage",
          editAssets: true,
        },
        {
          description: "Upload resources",
          icon: "mdi-file-upload",
          onClick: "OpenImport",
          editAssets: true,
        },
        {
          description: "Download current resource",
          icon: "mdi-file-download",
          onClick: "DownloadCurrentResource",
          editAssets: false,
        },
        {
          description: "Download all resources",
          icon: "mdi-folder-download",
          onClick: "DownloadAllResources",
          editAssets: false,
        },
        {
          description: "Delete current resource",
          icon: "mdi-delete",
          onClick: "DeleteAssetResource",
          editAssets: true,
        },
      ],
    };
  },
  mounted() {
    this.SetResourceArrowVisibility(true);
    this.SetResourceViewExpansion(false);

    document.addEventListener("fullscreenchange", this.OnFullScreenChange);

    /* Firefox */
    document.addEventListener("mozfullscreenchange", this.OnFullScreenChange);

    /* Chrome, Safari and Opera */
    document.addEventListener(
      "webkitfullscreenchange",
      this.OnFullScreenChange
    );

    /* IE / Edge */
    document.addEventListener("msfullscreenchange", this.OnFullScreenChange);
  },
  methods: {
    ...mapActions("assetxpstate", [
      "GetAssetUploadResourceEndPoint",
      "GetAllAssetResources",
      "GetCurrentAssetResource",
      "RemoveAssetResource",
      "ToggleDefaultAssetResource",
      "UploadResources",
      "UploadResourceSequence",
      "UpdateAssetsWithImages",
      "UpdateResourceMeta",
    ]),

    ...mapMutations("sessionState", [
      "SetResourceArrowVisibility",
      "SetResourceViewExpansion",
    ]),

    ...mapGetters("authentication", ["CanUserEditAssets", "GetAuthHeaderObj"]),

    GetAutoCropTokens() {
      this.autoCropTokens = -1;
      axios
        .get(
          CONFIG.platformEndpoints.assetxpapi +
            "axpsettings/GetAutoCropAllowance",
          GetAuthorisationHeaderGroup()
        )
        .then((response) => {
          this.autoCropTokens = response.data;
        });
    },
    OnResourceMetaChange() {
      this.UpdateResourceMeta({
        assetDetailid: this.asset.assetDetailid,
        resourceid: resource.id,
        fileName: resource.name,
      });
    },
    OnShowDetails() {
      this.showResourceDetail = !this.showResourceDetail;
      this.actions[0].isToggled = this.showResourceDetail;
    },
    OnExpandResourceView() {
      this.SetResourceViewExpansion(!this.resourceViewExpanded);
    },
    OnFullScreenChange() {
      this.fullScreenMode = !this.fullScreenMode;

      if (this.fullScreenResourceMode && !this.fullScreenMode) {
        this.$data.hideResources = true;

        this.$nextTick().then(() => {
          // Add the component back in
          this.$data.hideResources = false;
        });

        this.fullScreenResourceMode = !this.fullScreenResourceMode;

        if (this.fullScreenResourceMode) {
          this.$data.carouselHeight = "100vh";
        } else {
          this.$data.carouselHeight = "400px";
        }
      }
    },
    ShowResourcesFullScreen() {
      if (!this.fullScreenResourceMode) {
        if (this.$refs.resourceCarousel.requestFullscreen) {
          this.$refs.resourceCarousel.requestFullscreen();
        } else if (this.$refs.resourceCarousel.mozRequestFullScreen) {
          /* Firefox */
          this.$refs.resourceCarousel.mozRequestFullScreen();
        } else if (this.$refs.resourceCarousel.webkitRequestFullscreen) {
          /* Chrome, Safari and Opera */
          this.$refs.resourceCarousel.webkitRequestFullscreen();
        } else if (this.$refs.resourceCarousel.msRequestFullscreen) {
          /* IE/Edge */
          this.$refs.resourceCarousel.msRequestFullscreen();
        }

        this.$data.hideResources = true;

        this.$nextTick().then(() => {
          // Add the component back in
          this.$data.hideResources = false;
        });

        this.fullScreenResourceMode = true;
        this.$data.carouselHeight = "100vh";
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          /* Chrome, Safari and Opera */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen();
        }
      }
    },
    HandleFunctionCall(functionName) {
      this[functionName]();
    },
    Cancel() {
      this.importDialog = false;
    },
    SetDefaultImage() {
      if (this.asset.resources.length > 0) {
        var resource = this.asset.resources[this.carouselIndex];

        this.ToggleDefaultAssetResource({
          assetDetailid: this.asset.assetDetailid,
          resourceid: resource.id,
        }).then(() => {
          this.$emit("reloadAsset");
          this.carouselIndex = 0;
        });
      }
    },
    OpenImport() {
      this.importDialog = true;
    },
    async updateAssetImages() {
      this.uploadingImages = true;

      let formData = new window.FormData();
      formData.set("assetDetailId", this.asset.assetDetailid);
      formData.set("autoCropEnabled", this.autoCropEnabled);

      for (var i = 0; i < this.$refs.upload.files.length; i++) {
        var file = this.$refs.upload.files[i];
        let value;

        for (let key in file.data) {
          value = file.data[key];
          if (
            value &&
            typeof value === "object" &&
            typeof value.toString !== "function"
          ) {
            if (value instanceof File) {
              formData.append(key, value, value.name);
            } else {
              formData.append(key, JSON.stringify(value));
            }
          } else if (value !== null && value !== undefined) {
            formData.append(key, value);
          }
        }

        formData.append(this.name, file.file, file.file.filename || file.name);
      }

      formData.append("replacementUpload", this.replacementUpload);
      formData.append(
        "seperateUnderscoresIntoTags",
        this.seperateUnderscoresIntoTags
      );

      if (this.uploadAs360Asset) {
        this.UploadResourceSequence(formData).then(() => {
          this.uploadingImages = false;
          this.importDialog = false;
          this.$emit("reloadAsset");
          this.$refs.upload.clear();
        });
      } else {
        this.UploadResources(formData).then((response) => {
          console.log("Got response", response);
          this.uploadingImages = false;
          this.importDialog = false;
          this.$emit("reloadAsset");
          this.$refs.upload.clear();
        });
      }
    },
    DownloadCurrentResource() {
      if (this.asset.resources.length > 0) {
        var resource = this.asset.resources[this.carouselIndex];

        this.GetCurrentAssetResource({
          assetDetailid: this.asset.assetDetailid,
          resourceid: resource.id,
          fileName: resource.name,
        });
      }
    },
    DownloadAllResources() {
      if (this.asset.resources.length > 0) {
        this.GetAllAssetResources(this.asset.assetDetailid);
      }
    },
    DeleteAssetResource() {
      if (this.asset.resources.length > 0) {
        this.confirmDeleteDialog = true;
      }
    },
    ConfirmDeleteResource() {
      this.confirmDeleteDialog = false;

      if (this.asset.resources.length > 0) {
        var resource = this.asset.resources[this.carouselIndex];

        this.RemoveAssetResource({
          assetDetailid: this.asset.assetDetailid,
          resourceid: resource.id,
        }).then(() => {
          this.$emit("reloadAsset");
        });
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }

        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }

      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;

        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }

        // Thumbnails
        newFile.thumb = "";

        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
    },
  },
  watch: {
    resourceViewExpanded: {
      handler(isExpanded) {
        if (isExpanded) {
          this.$data.carouselHeight = "690px";
        } else {
          this.$data.carouselHeight = "400px";
        }
      },
    },
    importDialog: {
      handler(showingDialog) {
        if (showingDialog) {
          this.GetAutoCropTokens();
        }
      },
    },
  },
};
</script>

<style scoped>
.icon-btn {
  width: 30px;
  height: 30px;
  margin: 0px;
  padding: 0px;
}
.v-row {
  margin: 0px;
  padding: 5px;
}

.resourceCarouselItem {
  overflow: hidden;
}

.resourceCarouselItem :deep(.v-image),
.resourceCarouselItem :deep(.v-responsive),
.resourceCarouselItem :deep(.v-carousel__item) {
  height: 100% !important;
  max-height: 100% !important;
  overflow: hidden !important;
}

.resourceCarouselItem :deep(.v-responsive__content) {
  height: 100% !important;
  max-height: 100% !important;
  overflow: hidden !important;
}
</style>
